import Axios from "axios";
import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../RequestConfig";
import { createRequest } from "helpers/tools";

export const getBigqueryDestinationUrl = async () => {
    return await createRequest({
        suffix: `google/bigquery/auth-url?type=destination`,
        method: "get",
        handleError: false,
    });
};

export const bigqueryDestinationAuthorize = async (data) => {
    return await createRequest({
        suffix: `google/bigquery/authorize`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getBigqueryDestinationTables = async (
    user_selected_project_id,
    user_selected_dataset_id,
    install_id,
) => {
    return await createRequest({
        suffix: `google/bigquery/tables?project=${user_selected_project_id}&dataset=${user_selected_dataset_id}&install_id=${install_id}`,
        method: "get",
        handleError: false,
    });
};

// Kept on Axios: consumers rely on the top-level `errors` field returned on failure.
export const createBigqueryDataset = async (data) => {
    let requestURL = baseURL + `/api/google/bigquery/store/dataset`;
    let responseResult = {
        status: "",
        message: "",
        data: "",
    };
    await Axios.post(requestURL, data, RequestConfig())
        .then((response) => {
            responseResult = {
                status: true,
                message: response.data?.message || response.message,
                data: response.data && response.data,
            };
        })
        .catch((error) => {
            responseResult = {
                status: false,
                message: error.response?.data?.message,
                errors: error.response?.data?.errors,
            };
        });
    return responseResult;
};

// Kept on Axios: consumers rely on the top-level `errors` field returned on failure.
export const createBigqueryTable = async (data) => {
    let requestURL = baseURL + `/api/google/bigquery/store/table`;
    let responseResult = {
        status: "",
        message: "",
        data: "",
    };
    await Axios.post(requestURL, data, RequestConfig())
        .then((response) => {
            responseResult = {
                status: true,
                message: response.data?.message || response.message,
                data: response.data && response.data,
            };
        })
        .catch((error) => {
            responseResult = {
                status: false,
                message: error.response?.data?.message,
                errors: error.response?.data?.errors,
            };
        });
    return responseResult;
};

export const createDestinationBigquery = async (data) => {
    return await createRequest({
        suffix: `google/bigquery/store/destination`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
